import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import translation files
import ruTranslations from './locales/ru.json';
import enTranslations from './locales/en.json';
import ruPlatform from './locales/ru_platform.json';
import enPlatform from './locales/en_platform.json';
// import ptTranslations from './locales/pt.json';

// Configuration for i18next

// Неймспейс для страницы метрики/цефалометрии
import ruMetrica from './locales/ru_metrica.json';
import enMetrica from './locales/en_metrica.json';
import ptMetrica from './locales/pt_metrica.json';

i18n
  .use(LanguageDetector) // Detects user's language
  .use(initReactI18next) // Passes i18n down to react-i18next
  .init({
    resources: {
      ru: {
        translation: { ...ruTranslations, pl: ruPlatform },
        metrica: ruMetrica
      },
      en: {
        translation: { ...enTranslations, pl: enPlatform },
        metrica: enMetrica
      },
    pt: {
        // translation: ptTranslations,
        metrica: ptMetrica
      },
    },
    fallbackLng: 'ru', // Default language
    debug: process.env.NODE_ENV === 'development', // Enable debug mode in development
    
    interpolation: {
      escapeValue: false, // React already safes from XSS
    },
    
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag', 'path', 'subdomain'],
      caches: ['localStorage', 'sessionStorage'],
    },
  });

export default i18n;